module.exports = __webpack_public_path__ + "img/gift-card.4f0e2324.svg";